import React from 'react';

import * as S from './EarlyCheckInModal.styles';

type EarlyCheckInModalContentProps = {
  charges_value: number;
  pay_mode_text: string;
  units: number;
  text: string;
  addCheckin: Function;
  roomType: string;
};

const EarlyCheckInModal: React.FC<EarlyCheckInModalContentProps> = ({
  charges_value: amount,
  pay_mode_text: payModeText,
  units: quantity,
  text: name,
  addCheckin,
  roomType,
}) => (
  <S.EarlyCheckInPopUpwrap>
    <S.EarlyCheckInHeaderWrap>
      <S.EarlyCheckInTitle>{roomType}</S.EarlyCheckInTitle>
    </S.EarlyCheckInHeaderWrap>

    <S.AddOnOuterWrapper>
      <S.AddOnInnerWrapper>
        <S.AddOnNameLabel>Add-on Name</S.AddOnNameLabel>
        <S.AddOnNameData>{name}</S.AddOnNameData>
      </S.AddOnInnerWrapper>

      <S.AddOnInnerWrapper>
        <S.AddOnNameLabel>Payment Method</S.AddOnNameLabel>
        <S.PayAtHotelBtn>{payModeText}</S.PayAtHotelBtn>
      </S.AddOnInnerWrapper>

      <S.AddOnInnerWrapper>
        <S.AddOnNameLabel>Quantity</S.AddOnNameLabel>
        <S.QuantityData>{quantity}</S.QuantityData>
      </S.AddOnInnerWrapper>

      <S.AddOnInnerWrapper>
        <S.AddOnNameLabel>Add-on Amount</S.AddOnNameLabel>
        <S.AddOnAmountData>₹{amount}</S.AddOnAmountData>
      </S.AddOnInnerWrapper>
    </S.AddOnOuterWrapper>

    <S.EarlyCheckInBtn onClick={addCheckin}>Add Early Check-in</S.EarlyCheckInBtn>
  </S.EarlyCheckInPopUpwrap>
);

export default EarlyCheckInModal;
